import { Box, Button, Typography } from "@mui/material";
import styles from "./SearchCandidate.module.css";
import { useNavigate } from "react-router-dom";

const ViewPublicResume = () => {

    const navigate = useNavigate()

    return (
        <Box
            sx={{ backgroundColor: "#f2f2f2", padding: "20px" }}
        >
            <Box className={styles.public_resume_header}>
                <Typography>KEVIN MACKLIN</Typography>
                <Typography>Lead Java Developer</Typography>
                <Typography>Phone No: 4245-407-***</Typography>
                <Typography>Kevinmackin*******.com</Typography>
                <Typography>LinkedIn URL:</Typography>
            </Box>
            <hr />
            <Box className={styles.resume_public_body}>
                <Typography>Professional Summary</Typography>
                <span>
                    Over 8+ years of successful professional experience in IT industry
                    as a DevOps Engineer and Software Configuration Management (SCM) and
                    Linux Systems Administration. Experience includes SCM, DevOps Build
                    & Release Management, and Cloud Management.
                </span>
            </Box>
            <hr />

            <Box className={styles.resume_public_body}>
                <Typography>Technical Skills</Typography>
                <span>
                    Over 8+ years of successful professional experience in IT industry
                    as a DevOps Engineer and Software Configuration Management (SCM) and
                    Linux Systems Administration. Experience includes SCM, DevOps Build
                    & Release Management, and Cloud Management.
                </span>
            </Box>
            <hr />
            <Box className={styles.public_resume_header}>
                <Typography>Lead Java Developer</Typography>
                <Typography>Client: Capital One</Typography>
                <Typography>From: 12 *******</Typography>
            </Box>
            <hr />
            <Box className={styles.resume_public_body}>
                <Typography>About Company</Typography>
                <span>
                    Over 8+ years of successful professional experience in IT industry
                    as a DevOps Engineer and Software Configuration Management (SCM) and
                    Linux Systems Administration. Experience includes SCM, DevOps Build
                    & Release Management, and Cloud Management.
                </span>
            </Box>
            <hr />

            <Box className={styles.resume_public_body}>
                <Typography>Responsibilities</Typography>
                <span>
                    Manipulated data using CRUD operations of MongoDB database
                    management system and handled database access using Node JS. Was
                    responsible for migrating and maintaining build and test
                    environments into the cloud infrastructure. Experience writingdata
                    APIs and multi-server applications to meet product needs in Golang 
                    Created Ansible scripts for EC2 instances, Elastic Load balancers
                    and S3 buckets, Planned, developed & maintained Infrastructure as
                    code using CI/CD deployments using Ansible. Involved in designing
                    and implementing CI (Continuous Integration) system, configuring
                    Jenkins servers, Jenkins nodes,
                </span>
            </Box>
            <hr />

            <Box className={styles.resume_public_body}>
                <Typography>Environment Area</Typography>
                <span>
                    Over 8+ years of successful professional experience in IT industry
                    as a DevOps Engineer and Software Configuration Management (SCM) and
                    Linux Systems Administration. Experience includes SCM, DevOps Build
                    & Release Management, and Cloud Management.
                </span>
            </Box>
            <Box className={styles.job_search_result_btns}>
                <Button sx={{ padding: '9px 90px !important' }}>Back</Button>
                <Button onClick={() => navigate('/post-request-submit')}>Send Requirement </Button>
            </Box>
        </Box>
    );
};

export default ViewPublicResume;
